import { useCallback, useEffect, useRef } from 'react';

// Calls callback() whenever focus changes
// with a bool of whether focus is inside the reference
const useOnFocusInsideChange = <T extends HTMLElement = HTMLElement>(
  callback: (isFocusInside: boolean) => void,
  toggleListener?: boolean
): React.RefObject<T> => {
  const ref = useRef<T>(null);

  const onAnyFocus = useCallback(() => {
    if (!ref.current) return;
    const isFocusInsideLink = ref.current.contains(document.activeElement);
    callback(isFocusInsideLink);
  }, [callback]);

  useEffect(() => {
    if (toggleListener || toggleListener === undefined) {
      document.addEventListener('focusin', onAnyFocus);
    } else if (toggleListener === false) {
      document.removeEventListener('focusin', onAnyFocus);
    }

    return () => document.removeEventListener('focusin', onAnyFocus);
  }, [toggleListener, onAnyFocus]);

  return ref;
};

export default useOnFocusInsideChange;
